const FOLLOW_NOTIFICATION_CATEGORIES = Object.freeze({
  gallery: Object.freeze([
    { id: 'artworks', titleKey: 'artworks', descriptionKey: 'most_relevant' },
    { id: 'posts_articles', titleKey: 'posts_articles', descriptionKey: 'most_relevant' },
    { id: 'channel', titleKey: 'channel', descriptionKey: 'most_relevant', requiresJoinedChannel: true },
    { id: 'artlists', titleKey: 'artlists', descriptionKey: 'most_relevant' }
  ]),
  artist: Object.freeze([
    { id: 'artworks', titleKey: 'artworks', descriptionKey: 'most_relevant' },
    { id: 'posts_articles', titleKey: 'posts_articles', descriptionKey: 'most_relevant' },
    { id: 'channel', titleKey: 'channel', descriptionKey: 'most_relevant', requiresJoinedChannel: true },
    { id: 'artlists', titleKey: 'artlists', descriptionKey: 'most_relevant' }
  ]),
  collector: Object.freeze([
    { id: 'artworks', titleKey: 'artworks', descriptionKey: 'new_purchases' },
    { id: 'thoughts_ratings', titleKey: 'thoughts_ratings', descriptionKey: 'most_relevant' },
    { id: 'posts_articles', titleKey: 'posts_articles', descriptionKey: 'most_relevant' },
    { id: 'artlists', titleKey: 'artlists', descriptionKey: 'most_relevant' }
  ])
});

export function getFollowNotificationProfileType(profile) {
  const type = String(profile?.user_type || profile?.__t || '').trim().toLowerCase();
  return FOLLOW_NOTIFICATION_CATEGORIES[type] ? type : 'collector';
}

export function getFollowNotificationCategories(profile, { hasJoinedChannel = false } = {}) {
  return FOLLOW_NOTIFICATION_CATEGORIES[getFollowNotificationProfileType(profile)]
    .filter((category) => !category.requiresJoinedChannel || hasJoinedChannel);
}

export function normaliseFollowNotificationPreferences(categories, preferences) {
  return Object.fromEntries(categories.map(({ id }) => [
    id,
    typeof preferences?.[id] === 'boolean' ? preferences[id] : true
  ]));
}

export function areChannelNotificationsEnabled(userSession) {
  const userType = String(userSession?.user_type || userSession?.__t || '').trim().toLowerCase();
  const sectionId = userSession?.gallery_id || userType === 'gallery'
    ? 'gallery_channels'
    : userType === 'artist'
      ? 'artist_channels'
      : 'collector_channels_and_chats';
  const channelPreferences = userSession?.user_preferences?.notification_preferences?.[sectionId];
  const joinedMessagesEnabled = typeof channelPreferences?.joined_channel_messages === 'boolean'
    ? channelPreferences.joined_channel_messages
    : channelPreferences !== false;
  const mentionsEnabled = typeof channelPreferences?.channel_mentions === 'boolean'
    ? channelPreferences.channel_mentions
    : channelPreferences !== false;

  return joinedMessagesEnabled || mentionsEnabled;
}
